<template lang="html">
  <v-page class="client wallet" :profile="profile">
    <v-topbar :profile="profile" />
    <v-breadcrumb :steps="[{ label: 'Carteira' }]" />

    <v-container class="mt-3">
      <v-alert close v-if="balances_data.total === 0">
        <strong>Você não possui créditos na sua carteira</strong><br />
        Conforme você atuar em contratos pela Vibbra, cada hora trabalhada será
        convertida em créditos na sua carteira após a aprovação dos Clientes.
        Havendo créditos disponíveis você poderá solicitar o resgate para a
        conta bancária informada no seu perfil.
      </v-alert>
      <v-row class="size-2">
        <v-col :xs="12" :sm="12" :md="12" :lg="4">
          <v-card class="m-0">
            <v-text
              slot="title"
              tag="h5"
              class="d-flex justify-content-between align-items-center"
              >Créditos disponíveis<span>{{
                balances_data.total | currency
              }}</span></v-text
            >
            <v-text slot="title" tag="h6" class="d-flex align-items-center">
              Próximos pagamentos
              <v-helper
                class="text-muted"
                title="Próximos pagamentos"
                placement="top"
              >
                Previsão dos próximos pagamentos de Cliente nas datas de
                fechamentos das sprints correntes. É considerada a soma das
                horas trabalhadas até o momento em cada sprint.
              </v-helper>
            </v-text>
            <v-list>
              <v-item
                tag="li"
                v-for="release in balances_data.details"
                :key="n"
                class=""
              >
                <div class="d-flex justify-content-between align-items-center">
                  {{ release.client_name }}
                  <div>
                    {{ release.next_paid_value | currency }} ({{
                      release.next_paid_hours
                    }}h)
                  </div>
                </div>
                <div class="text-right">
                  <span
                    class="badge badge-warning"
                    v-if="release.pending_payments === true"
                    >Pendente</span
                  >
                  <small
                    >Sprint atual fecha em
                    {{ release.next_paid_date | moment('DD/MM') }}</small
                  >
                </div>
              </v-item>
            </v-list>
            <v-inner :size="2" class="d-flex justify-content-center">
              <v-button
                v-if="parseFloat(balances_data.total).toFixed(2) > 0 && 
                  !(vibbrante.is_cooperated === true && parseFloat(balances_data.total).toFixed(2) < 1518)"
                class="primary block"
                @click="money_transfer_modal_show = true"
                >Resgatar créditos</v-button
              >
            </v-inner>
            <v-inner
              :size="2"
              class="d-flex justify-content-center"
              v-if="
                vibbrante.is_cooperated === true &&
                  parseFloat(balances_data.total).toFixed(2) < 1518
              "
            >
              <small
                >Valor mínimo para resgate por cooperativa cooperado é
                R$1.518,00.</small
              >
            </v-inner>
          </v-card>
        </v-col>
        <v-col :xs="12" :sm="12" :md="12" :lg="8">
          <v-card class="statement m-0">
            <v-text slot="title" tag="h5" class="statement-title">
              Extrato
              <v-input
                type="datepicker"
                :dateFormat="'MM/yyyy'"
                class="dropdown-right ml-3"
                :minimumView="'month'"
                :maximumView="'month'"
                :size="1"
                placeholder="Selecione um mês"
                v-model="selected_month"
              ></v-input>
            </v-text>
            <v-text
              slot="title"
              tag="h6"
              class="statement-title"
              v-if="extract_data.length === 0"
            >
              Nenhuma movimentação encontrada.
            </v-text>
            <v-list>
              <v-item
                tag="li"
                v-for="release in extract_data"
                class="d-md-flex justify-content-between align-items-center"
              >
                <div v-if="release.type === 'credit'">
                  <v-icon class="text-success" name="cash-up" />
                  Recebeu <b>{{ release.value | currency }}</b> em créditos de
                  <b>{{ release.client_name }}</b>
                </div>
                <div v-if="release.type === 'pending'">
                  <v-icon class="text-warning" name="cash-down" />
                  Solicitação de transferência no valor de
                  <b>{{ release.value | currency }}</b>
                </div>
                <div v-if="release.type === 'debit'">
                  <v-icon class="text-danger" name="cash-down" />
                  Transferência de
                  <b>{{ release.value | currency }} realizada</b>
                </div>
                <small>{{ release.date | moment('DD/MM/YYYY') }}</small>
              </v-item>
              <!-- <v-item tag="li" v-for="release in extract_data" class="d-md-flex justify-content-between align-items-center">
                <span class=""><v-icon class="text-danger"  name="cash-down"/> Transferiu <b>R$4.000</b>
                </span>
                <small>23/08/2018</small>
              </v-item> -->
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- MODALS -->
    <v-modals
      name="client"
      :show="client_modal_show"
      :data="{
        user: {
          name: 'Clarice',
          profession: 'Designer',
          specialty: 'UX',
          payperhour: 60,
          xpyears: 14,
          type: 0,
        },
      }"
      @onHide="client_modal_show = false"
    />
    <v-modals
      name="receipt"
      :show="receipt_modal_show"
      :data="{
        user: {
          name: 'Clarice',
          profession: 'Designer',
          specialty: 'UX',
          payperhour: 60,
          xpyears: 14,
          type: 0,
        },
      }"
      @onHide="receipt_modal_show = false"
    />
    <v-transfer-money
      name="money-transfer"
      :show="money_transfer_modal_show"
      :data="{
        user: {
          name: 'Clarice',
          profession: 'Designer',
          specialty: 'UX',
          payperhour: 60,
          xpyears: 14,
          type: 0,
        },
      }"
      @onHide="money_transfer_modal_show = false"
      @onTransferMoney="transferMoney()"
    />
    <v-modals
      name="wallet-add-credit"
      :show="add_credit_modal_show"
      :data="{}"
      @onHide="add_credit_modal_show = false"
    />
  </v-page>
</template>

<script>
import vibbranteApi from '@/api/vibbrante';
import TransferMoneyModal from '@/parts/modals/transfer-money';

export default {
  props: {
    profile: String,
  },
  components: {
    'v-transfer-money': TransferMoneyModal,
  },
  data() {
    return {
      pago: false,
      client_modal_show: false,
      receipt_modal_show: false,
      money_transfer_modal_show: false,
      add_credit_modal_show: false,
      extract_data: [],
      balances_data: [],
      selected_client: {},
      vibbrante: {},
      selected_month: this.$moment().format(),
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    selected_month(newValue) {
      this.reloadExtract(newValue);
    },
  },
  methods: {
    reloadExtract(month) {
      this.selected_month = month;
      vibbranteApi
        .vibbranteExtract(
          this.$moment(this.selected_month).format('YYYY-MM-01')
        )
        .then(response => {
          if (response.status === 200) {
            this.extract_data = response.data;
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    pagoAteAqui(n) {
      this.pago = n;
    },
    transferMoney() {
      this.fetchData();
    },
    fetchData() {
      vibbranteApi
        .loadActivesContracts()
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch(
              'loadVibbranteActivesContracts',
              response.data
            );
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });

      vibbranteApi
        .vibbranteExtract(
          this.$moment(this.selected_month).format('YYYY-MM-01')
        )
        .then(response => {
          if (response.status === 200) {
            this.extract_data = response.data;
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });

      vibbranteApi
        .vibbranteBalances()
        .then(response => {
          if (response.status === 200) {
            this.balances_data = response.data;
            this.$store.dispatch('loadVibbranteBalance', response.data);
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });

      vibbranteApi
        .getVibbranteData()
        .then(response => {
          if (response.status === 200) {
            this.vibbrante = response.data;
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
  },
};
</script>

<style lang="scss">
.wallet {
  .statement {
    .card-title {
      & > h5 {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .form-group {
          margin: 0;
        }
      }
    }
  }
  .cash-col {
    display: flex;
    flex-direction: column;
    align-items: center;

    h4 {
      font-weight: 300;
      font-size: 1.4em;
      color: gray(600);
      margin: 0;
      .icon {
        font-size: 0.7em;
        color: gray(400);
      }
      b {
        font-size: 1.6em;
        font-weight: 300;
        color: gray(900);
      }
    }
    h5 {
      font-size: 1.1em;
      margin: 0;
      color: gray(500);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/vibbrant/wallet.vue